import { render, staticRenderFns } from "./data12.vue?vue&type=template&id=bae88faa&scoped=true"
import script from "./data12.vue?vue&type=script&lang=js"
export * from "./data12.vue?vue&type=script&lang=js"
import style1 from "./data12.vue?vue&type=style&index=1&id=bae88faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae88faa",
  null
  
)

export default component.exports